import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

import { EventListItem } from '../types/events.types';

import { getRouteForEventType } from 'routes/referral/hooks/useEventTypeRedirect';

import { DEFAULT_EVENT_IMAGE } from '../constants';
import { formatDateRange } from '../utils';
import { RewardsList } from './RewardsList';

export const FeaturedSliderItem = ({ event }: { event: EventListItem }) => {
  const link = getRouteForEventType(event.event_type, event.id.toString());

  const imageUrl = event.image_url || DEFAULT_EVENT_IMAGE;
  const hasMoreThanTwoRewards = (event.rewards?.length || 0) > 2;

  return (
    <Link to={link}>
      <div className="tw-flex tw-h-full tw-flex-col-reverse tw-items-center tw-gap-[20px] lg:tw-flex-row lg:tw-gap-0">
        <div className="tw-flex tw-flex-1 tw-flex-col tw-items-center lg:tw-items-start lg:tw-gap-[10px]">
          <p className="tw-text-center tw-font-jost tw-text-[20px] tw-font-medium tw-leading-[24px] tw-text-white lg:tw-text-left lg:tw-text-[24px] lg:tw-font-bold lg:tw-leading-[40px]">
            {event.name}
          </p>
          <span className="tw-font-jost tw-text-[16px] tw-uppercase tw-leading-[50px] tw-text-[#20AA67] lg:tw-text-left">
            {formatDateRange(event.start_datetime, event.end_datetime)}
          </span>

          <RewardsList
            rewards={event.rewards}
            className={twMerge(
              'tw-mb-[10px] tw-max-w-[200px] lg:tw-mb-0',
              hasMoreThanTwoRewards ? 'tw-w-full' : 'tw-w-auto'
            )}
          />
        </div>
        <div className="tw-w-full lg:tw-hidden">
          <img src={imageUrl} alt={event.name} className="tw-w-full tw-rounded-[10px] tw-object-cover" />
        </div>
      </div>
    </Link>
  );
};
